import { ICookieOptions, setCookie } from '@cian/utils/lib/browser/cookie';
import { getCookie } from '../../../../../utils/cookie';
import { TRANSPORT_ACCESSIBILITY_ONBOARDING_COOKIE_KEY } from '../../../../../constants/map';

export function getOnboardingCookie() {
  const cookie = getCookie(TRANSPORT_ACCESSIBILITY_ONBOARDING_COOKIE_KEY);

  return Number(cookie) || 0;
}

export function setOnboardingCookie(times: number) {
  const cookieConfig: ICookieOptions = { expires: 365 * 86400, secure: false };
  const isLocalhost = typeof window !== undefined && window.location.hostname.indexOf('localhost') > -1;

  if (isLocalhost) {
    cookieConfig.domain = 'localhost';
  }

  setCookie(TRANSPORT_ACCESSIBILITY_ONBOARDING_COOKIE_KEY, `${times}`, cookieConfig);
}
